import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/facebook.svg'
import _imports_1 from '../assets/twitter.svg'
import _imports_2 from '../assets/linkedin.svg'


const _withScopeId = n => (_pushScopeId("data-v-fa870cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center w-full h-screen" }
const _hoisted_2 = { class: "text-3xl font-medium tracking-wide text-center text-white md:text-4xl md:w-1/2" }
const _hoisted_3 = { class: "block mb-2 text-4xl uppercase md:text-6xl" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-16 md:mx-12 md:my-24" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mapouter" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "gmap_canvas" }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        width: "100%",
        height: "500",
        id: "gmap_canvas",
        src: "https://maps.google.com/maps?q=32.831798,13.026481&t=&z=13&ie=UTF8&iwloc=&output=embed",
        frameborder: "0",
        scrolling: "no",
        marginheight: "0",
        marginwidth: "0"
      })
    ])
  ])
], -1))
const _hoisted_6 = { class: "mb-4 text-3xl text-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center\" data-v-fa870cac><a href=\"\" target=\"_blank\" data-v-fa870cac><img class=\"mx-5\" src=\"" + _imports_0 + "\" alt=\"\" loading=\"lazy\" data-v-fa870cac></a><a href=\"\" target=\"_blank\" data-v-fa870cac><img class=\"mx-5\" src=\"" + _imports_1 + "\" alt=\"\" loading=\"lazy\" data-v-fa870cac></a><a href=\"\" target=\"_blank\" data-v-fa870cac><img class=\"mx-5\" src=\"" + _imports_2 + "\" alt=\"\" loading=\"lazy\" data-v-fa870cac></a></div>", 1)
const _hoisted_8 = { class: "m-5 text-2xl text-center" }
const _hoisted_9 = {
  key: 0,
  class: "p-3 my-5 text-green-600 rounded-md bg-green-50"
}
const _hoisted_10 = {
  key: 1,
  class: "p-3 my-5 text-red-600 rounded-md bg-red-50"
}
const _hoisted_11 = { class: "grid grid-cols-1 gap-8 md:grid-cols-2" }
const _hoisted_12 = { class: "md:col-span-2" }
const _hoisted_13 = { class: "md:col-span-2" }
const _hoisted_14 = { class: "flex items-center justify-start md:justify-start" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  class: "animate-spin text-primary",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<circle cx=\"12\" cy=\"20\" r=\"2\" data-v-fa870cac></circle><circle cx=\"12\" cy=\"4\" r=\"2\" data-v-fa870cac></circle><circle cx=\"6.343\" cy=\"17.657\" r=\"2\" data-v-fa870cac></circle><circle cx=\"17.657\" cy=\"6.343\" r=\"2\" data-v-fa870cac></circle><circle cx=\"4\" cy=\"12\" r=\"2.001\" data-v-fa870cac></circle><circle cx=\"20\" cy=\"12\" r=\"2\" data-v-fa870cac></circle><circle cx=\"6.343\" cy=\"6.344\" r=\"2\" data-v-fa870cac></circle><circle cx=\"17.657\" cy=\"17.658\" r=\"2\" data-v-fa870cac></circle>", 8)
const _hoisted_25 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Subscribe = _resolveComponent("Subscribe")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('Contact.ContactUS')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('Contact.ContactP')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Contact.follow')), 1),
      _hoisted_7,
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
        class: "p-8 mx-5 my-12 bg-white rounded-md"
      }, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('Contact.ContactUS')), 1),
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('Contact.Success')), 1))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('Contact.error')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createVNode(_component_Field, {
              class: "w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary",
              id: "name",
              type: "text",
              name: "name",
              placeholder: _ctx.$t('Contact.form.name')
            }, null, 8, ["placeholder"]),
            _createVNode(_component_ErrorMessage, {
              name: "name",
              class: "text-red-600"
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Field, {
              class: "w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary",
              name: "company_name",
              id: "company_name",
              type: "text",
              placeholder: _ctx.$t('Contact.form.company_name')
            }, null, 8, ["placeholder"]),
            _createVNode(_component_ErrorMessage, {
              name: "company_name",
              class: "text-red-600"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Field, {
              class: "w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary",
              name: "email",
              id: "email",
              type: "email",
              placeholder: _ctx.$t('Contact.form.email')
            }, null, 8, ["placeholder"]),
            _createVNode(_component_ErrorMessage, {
              name: "email",
              class: "text-red-600"
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Field, {
              type: "textarea",
              class: "w-full p-3 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary h-36",
              name: "message",
              placeholder: _ctx.$t('Contact.form.message')
            }, null, 8, ["placeholder"]),
            _createVNode(_component_ErrorMessage, {
              name: "message",
              class: "text-red-600"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
            type: "submit",
            class: "px-8 py-2 my-5 font-bold border-4 border-primary rounded-2xl text-primary"
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('Contact.form.Submit')), 1))
              : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_25))
          ])
        ])
      ], 32),
      _createVNode(_component_Subscribe)
    ])
  ], 64))
}